import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickerBlockComponent } from './ticker-block.component';
import { TickerBlockItemComponent } from './ticker-block-item/ticker-block-item.component';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [TickerBlockComponent, TickerBlockItemComponent],
  imports: [CommonModule, MarkdownModule.forChild()],
  exports: [TickerBlockComponent],
})
export class TickerModule {}
